module.exports = __webpack_public_path__ + "media/flying-high-fredji-no-copyright-music.fc29e971.mp3";